const ModalIdViewMonkeyPatch = {
  initialize() {
    // Views launched using modal-id are no longer supported by interfaces
    // I pulled this monkey-patch from @dma's unmerged PR at https://github.com/planningcenter/interfaces/blob/cc1dc65751a0f0c224f5dd7eabcf2439f0e379dd/app/assets/javascripts/interfaces/modal.js.coffee
    if (window.INTERFACES == null) {
      window.INTERFACES = {}
    }
    if (window.INTERFACES.errors == null) {
      window.INTERFACES.errors = {}
    }

    INTERFACES.ModalView = class ModalView {
      constructor(content) {
        this.show = this.show.bind(this)
        this.catchAndLogContentErrors = this.catchAndLogContentErrors.bind(this)
        this.publishModalLoad = this.publishModalLoad.bind(this)
        if (content == null) {
          content = ""
        }
        this.content = content
        this.catchAndLogContentErrors()
      }

      show() {
        INTERFACES.modalLayer.emptyAndPushModal(this.content)
        return this.publishModalLoad()
      }

      catchAndLogContentErrors() {
        const $content = $(this.content)
        return $content
      }

      // It is less good that this event is called `modal:load`
      // now that it is triggered on all modals. What shold be?
      publishModalLoad() {
        return $(document).trigger("modal:load")
      }
    }

    INTERFACES.ModalPushView = class ModalPushView extends INTERFACES.ModalView {
      constructor() {
        super()
        this.show = this.show.bind(this)
      }

      show() {
        INTERFACES.modalLayer.pushAndEmptyModal(this.content)
        return this.publishModalLoad()
      }
    }

    INTERFACES.ModalIdView = class ModalIdView extends INTERFACES.ModalView {
      constructor(id) {
        const element = $(`#${id}`)
        super(element.detach())
        this.show = this.show.bind(this)
        this.handleModalHide = this.handleModalHide.bind(this)
        this.id = id
        this.element = $(`#${this.id}`)
        this.originalParent = this.element.parent()
        this.hideEvent = `modal:hide.ModalIdView_${this.id}`
      }

      show() {
        super.show(...arguments).show()

        return $(document).on(this.hideEvent, this.handleModalHide)
      }

      handleModalHide() {
        $(document).off(this.hideEvent)

        return this.element.detach().appendTo(this.originalParent)
      }
    }

    INTERFACES.ModalUrlView = class ModalUrlView extends INTERFACES.ModalView {}
  }
}

export default ModalIdViewMonkeyPatch
